import React, { useRef, useEffect } from 'react'
import { Carousel } from 'antd-mobile'
import styles from './index.module.less'
import { px2rem } from '@/utils/styleUtils'
import { isDuApp } from '@/utils/appUtils/getDevice'
import appInstall from '@/utils/appUtils/appInstall'
import Jockeys from '@/utils/jockey'
import imgResize from '@/utils/img-resize'
import Image from '../../base-components/image'

import { useWithReactFunctionalTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './trackConfig'
function Index(props) {
  const { propsConfig = {} } = props
  const { explosiveBg, explosiveList = [], bottomHeight = 0, imgTopHeight = 0 } = propsConfig
  const bgStyle = {
    height: px2rem(331 + bottomHeight),
    backgroundImage: `url(${explosiveBg ? imgResize(explosiveBg, 750) : ''})`,
  }
  const imgStyle = {
    marginTop: px2rem(-imgTopHeight),
  }
  const dotNormal = {
    height: px2rem(3),
    width: px2rem(3),
    background: 'rgb(229, 229, 229)',
  }
  const dotActive = {
    height: px2rem(4),
    width: px2rem(4),
    background: 'rgb(255, 255, 255)',
  }

  const functionalProps = { ...props }

  // 使用hook useEffect api ，当ref有值则组件渲染结束，props可挂载并执行$track函数
  const functionalRef = useRef(null)

  function refReadyCallback() {
    // 触发第一张轮播图的曝光埋点
    if ((window as any).editorFlag === 'edit') return
    functionalProps.$track('poizon_venue_component_content_exposure', { index: 0 })
  }
  useWithReactFunctionalTrack({
    functionalRef,
    functionalProps,
    useEffect,
    refReadyCallback,
    createTrackConfig,
  })

  function handleClick(e, { redirect }) {
    if (window.editorFlag === 'edit') return

    // html跳转
    if (redirect.landType === '1' && redirect.href === '') {
      return
    }
    if (redirect.landType === '1') {
      window.location.href = redirect.href
      return
    }
    // 指定落地页跳转
    // 商详页
    if (redirect.landType === '2') {
      // 站内走场景还原，站外走h5跳转
      const searchParams = new URLSearchParams(redirect.query)
      if (isDuApp()) {
        Jockeys.openNativePage('/sell/productDetail', {
          spuId: searchParams.get('spuId'),
        })
      } else {
        appInstall('/sell/productDetail', { spuId: searchParams.get('spuId') })
      }
    }
  }

  const afterChange = (index) => {
    if ((window as any).editorFlag === 'edit') return
    functionalProps.$track &&
      functionalProps.$track('poizon_venue_component_content_exposure', { index })
  }

  if (typeof window === 'undefined') {
    return <span></span>
  }
  return (
    <div className={styles.wrap} style={bgStyle} ref={functionalRef}>
      <Carousel
        className={styles.carousel}
        autoplay={true}
        infinite
        autoplayInterval={3000}
        dotStyle={dotNormal}
        dotActiveStyle={dotActive}
        afterChange={(index) => afterChange(index)}
      >
        {explosiveList.map((item, index) => {
          return (
            <div className={styles.list} key={index}>
              <div
                onClick={(e) => handleClick(e, item)}
                data-track-click="poizon_venue_component_content_click"
                data-index={index}
              >
                <Image
                  src={item.imgUrl}
                  options={[{ mode: 'resize', width: 750 }]}
                  className={styles.img}
                  style={imgStyle}
                />
              </div>
              <span className={styles.description}>
                <strong className={styles.title}>{item.title}</strong>
                <i className={styles.subtitle}>{item.subTitle}</i>
              </span>
            </div>
          )
        })}
      </Carousel>
    </div>
  )
}

Index.config = {
  name: 'poizon-explosiveBigPicture',
}

export default Index
